/* Built In Imports */
/* External Imports */
import FlocklerEmbed from '@flockler/react-flockler-embed';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';

/* Services */
/* Styles */

/**
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} MediaEmbed component
 */
const FlocklerEmbedWidget = ({ sectionContent }) => {
  return sectionContent.siteuuid && sectionContent.embeduuid && (
    <MidContainer>
      <FlocklerEmbed height="360px" siteUuid={sectionContent.siteuuid} embedUuid={sectionContent.embeduuid} />
    </MidContainer>
  );
};

export default FlocklerEmbedWidget;
